import React from 'react'
import * as S from './textAreaStyle'

export interface iTextArea {
    id: string;
    name?: string;
    className?: string;
    placeholder?: string;
    disabled?: boolean;
    value?: string | any;
    onTextAreaChange?: (event: any) => void;
}

const Input: React.FC<iTextArea> = (props) => {
    const { id, className, placeholder, value, onTextAreaChange, name, disabled } = props
    
    return (
        <S.TextArea
            id={id}
            value={value}
            onChange={onTextAreaChange}
            className={className}
            placeholder={placeholder}
            name={name}
            disabled={disabled}
        >
        </S.TextArea>
    )

}

export default Input